<template>
  <div class="doorpostdescribe">
    <div class="header">
      <div class="title">完整的智慧防疫业务流程</div>
      <div class="border"></div>
    </div>

    <div class="text1">
      目前疫情防控所面临的问题是：疫情反复出现、新冠病毒的各种变异、检测人员信息统计不到位、重点人员监管难等，这些问题对疫情防控提出更高的要求。因此畅月数字家园智慧防疫整体解决方案针对这几项重点问题进行有效突破。
    </div>

    <div class="list">
      <div
        class="item"
        v-for="item in list"
        :key="item.id"
        :style="`background-image: url(${item.back});`"
      >
        <div class="position">
          <img :src="item.logo" alt="" />
          <div class="title" :style="`color: ${item.color}`">
            {{ item.title }}
          </div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import EPBusiness1 from "../../../../assets/programme/EPBusiness1.png";
import EPBusiness2 from "../../../../assets/programme/EPBusiness2.png";
import EPBusiness3 from "../../../../assets/programme/EPBusiness3.png";
import EPBusiness4 from "../../../../assets/programme/EPBusiness4.png";

import EPBusinessBack1 from "../../../../assets/programme/EPBusinessBack1.png";
import EPBusinessBack2 from "../../../../assets/programme/EPBusinessBack2.png";
import EPBusinessBack3 from "../../../../assets/programme/EPBusinessBack3.png";
import EPBusinessBack4 from "../../../../assets/programme/EPBusinessBack4.png";

export default {
  setup() {
    return reactive({
      list: [
        {
          id: 1,
          logo: EPBusiness1,
          title: "后台数据精准计算",
          text: "畅月数字家园有专业后台工程师进行数据表格统计及分析，精准研判与决策。",
          color: "#02B8FE",
          back: EPBusinessBack1,
        },
        {
          id: 2,
          logo: EPBusiness2,
          title: "大数据分析",
          text: "畅月数字家园智慧防疫平台全天候、无接触进行数据采集，借助可视化大屏清晰展示数据并进行分析。",
          color: "#4C94FF",
          back: EPBusinessBack2,
        },
        {
          id: 3,
          logo: EPBusiness3,
          title: "远程监控",
          text: "利用移动端及硬件设备进行远程监控，无接触精细化监督、防疫人员位置实时监控。",
          color: "#0080EA",
          back: EPBusinessBack3,
        },
        {
          id: 4,
          logo: EPBusiness4,
          title: "异常预警处理",
          text: "可视化大屏实时展示防控信息，防控人员异常监测，实时报警，做到异常情况立刻处理。",
          color: "#006EE5",
          back: EPBusinessBack4,
        },
      ],
    });
  },
};
</script>

<style scoped>
.doorpostdescribe {
  width: 92vw;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.text1 {
  font-size: 14px;
  color: #495a6c;
  margin-top: 16px;
  text-align: center;
}

.list {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 24px;
  text-align: center;
}
.list .item {
  width: 166px;
  height: 142px;
  position: relative;
  border-radius: 30px;
  margin-bottom: 60px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
}
.list .item .position {
  width: 140px;
  height: 160px;
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  background: #f2f2f2;
  box-shadow: 6px 6px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 23px 23px 23px 23px;
  padding: 8px;
}
.list .item .position img {
  width: 50px;
}
.list .item .position .title {
  font-size: 14px;
  margin-top: 8px;
  font-weight: 600;
}
.list .item .position .text {
  font-size: 12px;
  color: #495a6c;
  text-align: left;
  margin-top: 4px;
}
</style>
